<div class="reminder-card" [class.completed]="reminder.completed"
  [class.overdue]="reminder.overdue && !reminder.completed"
  [class.urgent]="isUrgent()">
  <div class="reminder-card-header">
    <!-- Icon -->
    <div [ngClass]="getIconContainerClasses()" [class.opacity-50]="reminder.completed">
      <mat-icon>{{ getTypeIcon(reminder.type) }}</mat-icon>
    </div>

    <!-- Content -->
    <div class="reminder-content">
      <div class="reminder-title-row">
        <div class="reminder-title-left">
          <h4 class="reminder-title" [class.line-through]="reminder.completed">
            {{ reminder.title }}
          </h4>
          @if (reminder.overdue && !reminder.completed) {
            <span class="reminder-overdue-badge">
              Overdue
            </span>
          }
        </div>
        <mat-icon class="reminder-status-icon" [ngClass]="statusInfo.cssClass"
        [matTooltip]="statusInfo.tooltip" matTooltipPosition="above">{{ statusInfo.icon }}</mat-icon>
      </div>

      <!-- Context row: linked entity (customer + bid) on the left, time + due-in pinned to the right -->
      <div class="reminder-info-row">
        <div class="reminder-info-left">
          @if (reminder.reminderable?.customer_name) {
            <div class="reminder-meta-item">
              <mat-icon>person</mat-icon>
              <span [class.reminder-meta-link]="reminder.reminderable?.customer_id"
                [matTooltip]="reminder.reminderable?.customer_id ? 'View customer' : ''"
                matTooltipPosition="above"
              (click)="navigateToCustomer($event)">{{ reminder.reminderable?.customer_name }}</span>
            </div>
          }
          @if (reminder.reminderable?.customer_name && reminder.reminderable?.bid_name) {
            <span class="reminder-separator"
            >&#8226;</span>
          }
          @if (reminder.reminderable?.bid_name) {
            <div class="reminder-meta-item">
              <mat-icon>description</mat-icon>
              <span [class.reminder-meta-link]="reminder.reminderable?.bid_id"
                [matTooltip]="reminder.reminderable?.bid_id ? 'View bid' : ''"
                matTooltipPosition="above"
              (click)="navigateToBid($event)">{{ reminder.reminderable?.bid_name }}</span>
            </div>
          }
          @if (reminder.location) {
            @if (reminder.reminderable?.customer_name || reminder.reminderable?.bid_name) {
              <span class="reminder-separator"
              >&#8226;</span>
            }
            <div class="reminder-location">
              <mat-icon>location_on</mat-icon>
              <span class="truncate">{{ reminder.location }}</span>
            </div>
          }
        </div>
        <div class="reminder-time-inline">
          <div class="reminder-time"
            [matTooltip]="(reminderDateTime | date:'MMM d, yyyy h:mm a') || ''"
            matTooltipPosition="above">
            <mat-icon>schedule</mat-icon>
            <span>{{ (reminderDateTime | date:'h:mm a') || reminder.time }}</span>
          </div>
          @if (reminder.status === 'pending') {
            <span class="reminder-separator">&#8226;</span>
            <span class="reminder-due-in" [class.overdue-text]="reminder.overdue && !reminder.completed">
              {{ dynamicDueIn$ | async }}
            </span>
          }
        </div>
      </div>

      <!-- Actions -->
      <div class="reminder-actions">
        <button class="btn-complete" [class.completed]="reminder.completed" (click)="handleComplete()">
          @if (reminder.completed) {
            <mat-icon>check</mat-icon>
            Done
          }
          @if (!reminder.completed) {
            Complete
          }
        </button>

        @if (!reminder.completed) {
          <div class="snooze-wrapper">
            <button #snoozeBtn class="btn-snooze" (click)="handleSnoozeToggle()">
              <mat-icon>schedule</mat-icon>
              Snooze
            </button>
          </div>
          <button class="btn-dismiss" (click)="handleDismiss()">
            Dismiss
          </button>
          <button class="btn-edit" (click)="handleEdit()" aria-label="Edit reminder">
            <mat-icon>edit_square</mat-icon>
          </button>
        }
      </div>
    </div>
  </div>
</div>

<!-- Snooze Dropdown - Rendered outside card with fixed positioning -->
@if (snoozeOpen) {
  <div class="snooze-dropdown-overlay"
    [style.top.px]="snoozeDropdownPosition.top"
    [style.left.px]="snoozeDropdownPosition.left">
    @for (duration of snoozeDurations; track duration) {
      <button class="snooze-option"
        (click)="handleSnooze(duration.value)">
        {{ duration.label }}
      </button>
    }
  </div>
}